import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-fm-message-alerts',
  templateUrl: './fm-message-alerts.component.html',
  styleUrls: ['./fm-message-alerts.component.scss'],
})
export class FmMessageAlertsComponent implements OnInit {
  @Input() messageTitle: string;
  @Input() messageBody: string;
  @Input() messageType: string;

  public isNotice = false;
  public isSuccess = false;
  public isInfo = false;
  public isErrorMessage = false;

  ngOnInit() {
    switch (this.messageType) {
      case 'notice': {
        this.isNotice = true;
        break;
      }
      case 'success': {
        this.isSuccess = true;
        break;
      }
      case 'info': {
        this.isInfo = true;
        break;
      }
      case 'error': {
        this.isErrorMessage = true;
        break;
      }
      default: {
        this.isInfo = true;
        break;
      }
    }
  }
}
